import {
  ENCARGOS_CREACION_INICIALIZAR_REQUEST,
  ENCARGOS_CREACION_ESTABLECER_PROPIEDAD_CABECERA,
  ENCARGOS_CREACION_ESTABLECER_CLIENTE,
  ENCARGOS_CREACION_ESTABLECER_GRADUACIONES,
  ENCARGOS_CREACION_MOSTRAR_GRADUACIONES,
  ENCARGOS_CREACION_OCULTAR_GRADUACIONES,
  ENCARGOS_CREACION_ESTABLECER_GRADUACION,
  ENCARGOS_CREACION_ARTICULOS_ESTABLECER_A_LINEA,
  ENCARGOS_CREACION_BUSCAR_Y_ESTABLECER_ARTICULO_A_LINEA,
  ENCARGOS_CREACION_ARTICULOS_BORRAR_LINEA,
  ENCARGOS_CREACION_ARTICULOS_AÑADIR_A_LINEA_CON_FORMA,
  ENCARGOS_CREACION_APLICAR_DESCUENTO,
  OBTENER_SUPLEMENTOS_LENTE_REQUEST,
  ENCARGOS_CREACION_MODIFICAR_PRECIO_LINEA,
  ENCARGOS_CREACION_ARTICULOS_AGREGAR_LINEA,
  ENCARGOS_CREACION_ARTICULOS_MODIFICAR_UNIDADES,
  ENCARGOS_CREACION_BORRAR_DESCUENTO,
  ENCARGOS_CREACION_GUARDAR_REQUEST,
  ENCARGOS_CREACION_EXPANDIR_ENCARGO,
  ENCARGOS_CREACION_CONTRAER_ENCARGO,
  ENCARGOS_CREACION_ARTICULOS_MODIFICAR_NUMERO_LOTE,
  ENCARGOS_CREACION_ARTICULOS_CREAR_ESTABLECER_A_LINEA,
  ENCARGOS_CREACION_ELIMINAR_CLIENTE,
  ENCARGOS_CREACION_SELECCIONAR_MONTURA_GAFA_GRADUADA,
  ENCARGOS_CREACION_SET_GAFA_GRADUADA,
  ENCARGOS_CREACION_ARTICULOS_TEMPORAL_CREAR_ESTABLECER_A_LINEA,
} from '../constants/encargos.creador.constants';

export const inicializarCreadorEncargos = ({ promocionId, uuid }) => ({
  type: ENCARGOS_CREACION_INICIALIZAR_REQUEST,
  payload: { promocionId, uuid },
});

export const establecerPropiedadDeCabecera = ({ nombre, encargoUUID, valor }) => ({
  type: ENCARGOS_CREACION_ESTABLECER_PROPIEDAD_CABECERA,
  payload: { nombre, encargoUUID, valor },
});

export const establecerCliente = ({ cliente, encargoUUID }) => ({
  type: ENCARGOS_CREACION_ESTABLECER_CLIENTE,
  payload: { cliente, encargoUUID },
});
export const onClickEliminarCliente = ({ cliente, encargoUUID }) => ({
  type: ENCARGOS_CREACION_ELIMINAR_CLIENTE,
  payload: { cliente, encargoUUID },
});

export const establecerGraduaciones = ({ graduaciones, encargoUUID }) => ({
  type: ENCARGOS_CREACION_ESTABLECER_GRADUACIONES,
  payload: { graduaciones, encargoUUID },
});

export const establecerGraduacion = ({ graduacionId, encargoUUID, tipo }) => ({
  type: ENCARGOS_CREACION_ESTABLECER_GRADUACION,
  payload: { graduacionId, encargoUUID, tipo },
});

export const mostrarGraduaciones = ({ encargoUUID }) => ({
  type: ENCARGOS_CREACION_MOSTRAR_GRADUACIONES,
  payload: { encargoUUID },
});

export const ocultarGraduaciones = ({ encargoUUID }) => ({
  type: ENCARGOS_CREACION_OCULTAR_GRADUACIONES,
  payload: { encargoUUID },
});

export const addArticulo = ({ encargoUUID, linea, articulo }) => ({
  type: ENCARGOS_CREACION_ARTICULOS_CREAR_ESTABLECER_A_LINEA,
  payload: { encargoUUID, linea, articulo },
});
export const addArticuloTemporal = ({ encargoUUID }) => ({
  type: ENCARGOS_CREACION_ARTICULOS_TEMPORAL_CREAR_ESTABLECER_A_LINEA,
  payload: { encargoUUID },
});

export const seleccionarMonturaGafaGraduada = ({ encargoUUID, linea, articulo }) => ({
  type: ENCARGOS_CREACION_SELECCIONAR_MONTURA_GAFA_GRADUADA,
  payload: { encargoUUID, linea, articulo },
});
export const establecerArticulo = ({ encargoUUID, linea, articulo }) => ({
  type: ENCARGOS_CREACION_ARTICULOS_ESTABLECER_A_LINEA,
  payload: { encargoUUID, linea, articulo },
});
export const addFormaArticulo = ({ encargoUUID, linea, datosForma }) => ({
  type: ENCARGOS_CREACION_ARTICULOS_AÑADIR_A_LINEA_CON_FORMA,
  payload: { encargoUUID, linea, datosForma },
});
export const searchAndAddArticulo = ({ encargoUUID, linea, codigo }) => ({
  type: ENCARGOS_CREACION_BUSCAR_Y_ESTABLECER_ARTICULO_A_LINEA,
  payload: { encargoUUID, linea, codigo },
});

export const borrarLinea = ({ encargoUUID, linea }) => ({
  type: ENCARGOS_CREACION_ARTICULOS_BORRAR_LINEA,
  payload: { encargoUUID, linea },
});

export const aplicarDescuento = ({ encargoUUID, linea, descuento }) => ({
  type: ENCARGOS_CREACION_APLICAR_DESCUENTO,
  payload: { encargoUUID, linea, descuento },
});

export const borrarDescuento = ({ encargoUUID, linea }) => ({
  type: ENCARGOS_CREACION_BORRAR_DESCUENTO,
  payload: { encargoUUID, linea },
});

export const modificarPrecioLinea = ({ encargoUUID, linea, precio }) => ({
  type: ENCARGOS_CREACION_MODIFICAR_PRECIO_LINEA,
  payload: { encargoUUID, linea, precio },
});
export const obtenerSuplementosLente = params => ({
  type: OBTENER_SUPLEMENTOS_LENTE_REQUEST,
  payload: params,
});
export const setLentes = ({ encargoUUID, linea, params: { lentes, suplementos } }) => ({
  type: 'ENCARGOS_CREACION_SET_LENTES',
  payload: {
    encargoUUID, linea, lentes, suplementos,
  },
});
export const setGafaGraduada = ({ encargoUUID, linea, params }) => ({
  type: ENCARGOS_CREACION_SET_GAFA_GRADUADA,
  payload: {
    encargoUUID, linea, params,
  },
});
export const setVisibleVentanaSuplementos = visible => ({
  type: 'ENCARGOS_CREACION_SET_VISIBLE_VENTANA_ADD_SUPLS',
  payload: visible,
});
export const agregarLinea = ({ encargoUUID, agrupacion }) => ({
  type: ENCARGOS_CREACION_ARTICULOS_AGREGAR_LINEA,
  payload: { encargoUUID, agrupacion },
});

export const modificarUnidades = ({ encargoUUID, linea, unidades }) => ({
  type: ENCARGOS_CREACION_ARTICULOS_MODIFICAR_UNIDADES,
  payload: { encargoUUID, linea, unidades },
});

export const guardarEncargos = () => ({
  type: ENCARGOS_CREACION_GUARDAR_REQUEST,
});

export const expandirEncargo = ({ encargoUUID }) => ({
  type: ENCARGOS_CREACION_EXPANDIR_ENCARGO,
  payload: { encargoUUID },
});

export const contraerEncargo = ({ encargoUUID }) => ({
  type: ENCARGOS_CREACION_CONTRAER_ENCARGO,
  payload: { encargoUUID },
});

export const modificarNumeroLote = ({ encargoUUID, linea, numeroLote }) => ({
  type: ENCARGOS_CREACION_ARTICULOS_MODIFICAR_NUMERO_LOTE,
  payload: { encargoUUID, linea, numeroLote },
});
